export default __webpack_public_path__ + "static/media/caret_up_white.397a84d8.svg";